
import React from 'react';

export const LoadingFallback: React.FC = () => (
  <div className="flex justify-center items-center h-full min-h-[20vh]">
    <div className="animate-pulse space-y-2">
      <div className="h-8 w-8 bg-slate-200 dark:bg-slate-700 rounded-full mx-auto"></div>
    </div>
  </div>
);
